import axios from "axios";
import { IPublicClientApplication } from "@azure/msal-browser";
import { apiRequest } from "../authConfig";

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/api`;

export interface EntityConfig {
  useMaterialCount: boolean;
  useMaterialQty:   boolean;
  useSupplier:      boolean;
  useHauler:        boolean;
  useBatchPageV2:   boolean;
}

export interface EntityDto extends EntityConfig {
  id: number;
  name: string;
  branches: string[];
}

export interface UpsertEntityRequest extends EntityConfig {
  name: string;
  branches: string[];
}

const auth = async (instance: IPublicClientApplication, account: any) => {
  const response = await instance.acquireTokenSilent({ ...apiRequest, account });
  return { headers: { Authorization: `Bearer ${response.accessToken}` } };
};

export const getMyEntityConfig = async (
  instance: IPublicClientApplication,
  account: any,
): Promise<EntityConfig> => {
  const config = await auth(instance, account);
  const res = await axios.get<EntityConfig>(`${API_URL}/entity/my-config`, config);
  return res.data;
};

export const getEntities = async (instance: IPublicClientApplication, account: any): Promise<EntityDto[]> => {
  const config = await auth(instance, account);
  const res = await axios.get<EntityDto[]>(`${API_URL}/entity`, config);
  return res.data;
};

export const createEntity = async (instance: IPublicClientApplication, account: any, body: UpsertEntityRequest) => {
  const config = await auth(instance, account);
  const res = await axios.post<EntityDto>(`${API_URL}/entity`, body, config);
  return res.data;
};

export const updateEntity = async (instance: IPublicClientApplication, account: any, id: number, body: UpsertEntityRequest) => {
  const config = await auth(instance, account);
  const res = await axios.put<EntityDto>(`${API_URL}/entity/${id}`, body, config);
  return res.data;
};

export const deleteEntity = async (instance: IPublicClientApplication, account: any, id: number) => {
  const config = await auth(instance, account);
  await axios.delete(`${API_URL}/entity/${id}`, config);
};
